import * as apiMethods from '../../consts/api/apiMethods';
import {setDeviceGroupTypes, setReportsData, setReportTypes} from '../../state/ducks/reports';
import ApiClient from '../api/clients/apiClient';
import ReportsApiClient from '../api/clients/reportsApiClient';
import downloadService from '../download/downloadService';
import log from '../logger/log';
import {
    deviceTypesGroupsDataMapping,
    generateReportRequestPostMapping,
    manipulateReportMapping,
    reportsListRequestDataMapping,
    reportTypesRequestDataMapping,
} from '../mappings/reportMappings';

const getReportsList = async ({options}) => {
    try {
        await new ApiClient().callPost({
            methodName: apiMethods.REPORTS_LIST,
            requestConfig: {
                data: options,
            },
            mapper: reportsListRequestDataMapping,
            action: setReportsData,
        });
    } catch (e) {
        log.error(`getReportsList: ${e}`);
    }
};

const getReportTypes = async () => {
    try {
        await new ApiClient().callGet({
            methodName: apiMethods.REPORTS_TYPES,
            mapper: reportTypesRequestDataMapping,
            action: setReportTypes,
        });
    } catch (e) {
        log.error(`getReportTypes: ${e}`);
    }
};

const fetchRawReportTypes = async () => {
    try {
        return await new ApiClient().callGet({
            methodName: apiMethods.REPORTS_TYPES,
        });
    } catch (e) {
        log.error(`fetchRawReportTypes: ${e}`);
    }
};

const getDeviceTypesGroups = async () => {
    try {
        alert('getDeviceTypeGroup API :  1 ');
        await new ApiClient().callGet({
            methodName: apiMethods.DEVICE_TYPES_GROUPS,
            mapper: deviceTypesGroupsDataMapping,
            action: setDeviceGroupTypes,
        });
    } catch (e) {
        log.error(`getDeviceTypeGroup: ${e}`);
    }
};

const generateReport = async ({values, onRequestSuccess}) => {
    try {
        console.log('GETTTT: ', values);

        if (!values.start_date) {
            values.start_date = '2020-01-01T21:59:59.999Z';
        }

        if (values.device_type.id === 1) {
            values.device_type = null;
        }

        console.log('VALUES AFTERR: ', values);

        await new ReportsApiClient().callPost({
            methodName: apiMethods.REPORTS,
            requestConfig: {
                data: generateReportRequestPostMapping(values),
            },
            onResponse: onRequestSuccess,
        });
    } catch (e) {
        log.error(`generateReport: ${e}`);
    }
};

const downloadReport = async (obj) => {
    try {
        console.log('DOWNLADDD: ', obj);

        const response = await new ApiClient().callPost({
            methodName: apiMethods.REPORTS_DOWNLOAD,
            requestConfig: {
                data: manipulateReportMapping(obj.ids),
            },
        });

        // Actually download the file before deleting the archive
        if (response && response.reportDownloadPath) {
            await downloadService.downloadFileByPath(response.reportDownloadPath);
        }

        await deleteReportArchive(response.reportDownloadPath);

        return response;
    } catch (e) {
        log.error(`downloadReport: ${e}`);
    }
};

const deleteReportArchive = async (filePath) => {
    try {
        await new ApiClient().callDelete({
            methodName: apiMethods.REMOVE_REPORTS_ARCHIVE,
            requestConfig: {
                data: {
                    filePath,
                },
            },
        });
    } catch (e) {
        log.error(`deleteReportArchive: ${e}`);
    }
};

const deleteReport = async (obj) => {
    try {
        await new ApiClient().callDelete({
            methodName: apiMethods.REPORTS,
            requestConfig: {
                data: manipulateReportMapping(obj.ids),
            },
            onResponse: obj.onRequestSuccess,
        });
    } catch (e) {
        log.error(`deleteReport: ${e}`);
    }
};

export default {
    getReportsList,
    deleteReport,
    getReportTypes,
    getDeviceTypesGroups,
    generateReport,
    downloadReport,
    fetchRawReportTypes,
};
